<nav class="navbar">
  <div class="logo">
    <a routerLink="/">MyApp</a>
  </div>
  <ul class="nav-links">
    <li><a routerLink="/">Home</a></li>
    <li><a routerLink="/about">About</a></li>
    <li><a routerLink="/services">Services</a></li>
    <li><a routerLink="/contact">Contact</a></li>
  </ul>
  <div class="menu-icon" (click)="toggleMenu()">
    ☰
  </div>
</nav>
@if (menuOpen) {
  <ul class="mobile-menu">
    <li><a routerLink="/" (click)="toggleMenu()">Home</a></li>
    <li><a routerLink="/about" (click)="toggleMenu()">About</a></li>
    <li><a routerLink="/services" (click)="toggleMenu()">Services</a></li>
    <li><a routerLink="/contact" (click)="toggleMenu()">Contact</a></li>
  </ul>
}

<ng-content></ng-content>
